import { render, staticRenderFns } from "./HomeMaxica.vue?vue&type=template&id=1b66e990&scoped=true"
import script from "./HomeMaxica.vue?vue&type=script&lang=js"
export * from "./HomeMaxica.vue?vue&type=script&lang=js"
import style0 from "./HomeMaxica.vue?vue&type=style&index=0&id=1b66e990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66e990",
  null
  
)

export default component.exports